/****************************************************************
 * File: pd-product-list.tsx
 * Description: 通用产品列表组件，用于展示产品应用
 * Author: AI Assistant
 * Created: 2024
 *****************************************************************/

import Link from 'next/link'
import { FC } from 'react'
import PdMedia from '../pd-media/pd-media'

export interface ProductItem {
  title: string
  desc?: string
  item?: string[]
  mediaUrl: string
  jumpUrl: string
  id?: number
}

export interface PdProductListProps {
  products: ProductItem[]
  className?: string
}

const PdProductList: FC<PdProductListProps> = ({ products, className = '' }) => {
  if (!products || products.length === 0) {
    return null
  }

  return (
    <div
      className={[
        'text-sm gap-2 grid grid-cols-3 ',
        'laptop:text-base laptop:gap-4 laptop:grid-cols-4',
        'text-black/90 font-semibold',
        className,
      ].join(' ')}
    >
      {products.map((product, index) => (
        <div key={product.id || product.title || index} className={['w-full h-full', 'relative text-center'].join(' ')}>
          <Link href={product?.jumpUrl || '#'}>
            <figure className="cursor-pointer w-full h-full bg-[#f3f4f5]">
              <div className="relative w-full mx-auto" style={{ paddingTop: '100%' }}>
                <div className="absolute top-0 left-0 w-full h-full">
                  <PdMedia
                    src={product.mediaUrl}
                    alt={product.title || 'product image'}
                    object={'contain'}
                    mask={false}
                    showShadow={false}
                  />
                </div>
              </div>
              <figcaption className="text-xs laptop:text-sm mt-2 mb-2">{product.title}</figcaption>
            </figure>
          </Link>
        </div>
      ))}
    </div>
  )
}

export default PdProductList
